exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail[data-v-751cc1a0]{padding:15px 70px 5px;background-color:#f8f8f8}.detail_item[data-v-751cc1a0]{width:33%;color:#999999;margin-bottom:10px}.detail_item label[data-v-751cc1a0]{color:#748cad;width:100px;display:inline-block}[data-v-751cc1a0] .el-table__expanded-cell{padding:0}\n", ""]);

// exports
